export const COURIER_TEMPLATES_BASE_URL = 'courier-templates';

// Commenda's Courier workspace (public URL identifier, not a secret).
const COURIER_WORKSPACE_ID = process.env.NEXT_PUBLIC_COURIER_WORKSPACE_ID ?? '';

// Courier has two editors; a template's id prefix tells us which, and each has a different designer
// URL path. (Content parsing keys off content shape instead — that's the backend's concern.)
type CourierEditorVersion = 'classic' | 'newDesigner';

const COURIER_DESIGNER_PATH: Record<CourierEditorVersion, string> = {
  newDesigner: 'new-designer',
  classic: 'content/templates',
};

const courierEditorVersion = (templateId: string): CourierEditorVersion =>
  templateId.startsWith('nt_') ? 'newDesigner' : 'classic';

export const courierTemplateDesignerUrl = (templateId: string): string =>
  `https://app.courier.com/${COURIER_WORKSPACE_ID}/production/${COURIER_DESIGNER_PATH[courierEditorVersion(templateId)]}/${templateId}/design`;
